<script setup>
import { ref, onMounted } from 'vue'
import router from '@/router.js'

const bar = ref(null)

onMounted(() => {
  router.beforeEach((to, from, next) => {
    bar.value.start()
    next()
  })
  router.afterEach(() => {
    bar.value.stop()
  })
})

</script>
<template>
  <q-ajax-bar
    ref="bar"
  />
  <Suspense>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </Suspense>
</template>
